<template>
  <div class="content">
    <div class="titlePic">
      <img src="@/assets/images/text.png" alt />
      <!-- <div class="title">

      </div>-->
    </div>
    <div class="mapBox">
      <div id="chart"></div>
    </div>
    <div class="time">
      <div class="timeOryq">
        <span class="beijin-time">截止北京时间{{ global.time }}</span>
        <div class="more">
          <span class="moreConfirm" @click="md">更多疫情信息</span>
          <span class="icon_right"></span>
        </div>
      </div>
    </div>
    <div class="tetailBox">
      <div class="tetail Cumulative-diagnosis">
        <div class="paddingBox">
          <p class="yesterday">较昨天+{{ this.global.addConfirm }}</p>
          <p class="number">{{ this.global.confirm }}</p>
          <p class="text">累计确诊</p>
        </div>
      </div>
      <div class="tetail Existing-diagnosis">
        <div class="paddingBox">
          <p class="yesterday">较昨天+{{ this.global.addCurrConfirm }}</p>
          <p class="number">{{ this.global.currConfirm }}</p>
          <p class="text">现有确诊</p>
        </div>
      </div>
      <div class="tetail Cumulative-cure">
        <div class="paddingBox">
          <p class="yesterday">较昨天+{{ this.global.addCure }}</p>
          <p class="number">{{ this.global.cure }}</p>
          <p class="text">累计治愈</p>
        </div>
      </div>
      <div class="tetail Existing-cure">
        <div class="paddingBox">
          <p class="yesterday">较昨天+{{ this.global.addDie }}</p>
          <p class="number">{{ this.global.die }}</p>
          <p class="text">累计死亡</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTxUnifiedData } from "@/api/countryEvent";
import { BASE_URL } from "@/utils/savePoint";
import axios from "axios";
export default {
  data() {
    return {
      getTime() {
        let T = new Date();
        let year = T.getFullYear();
        let month = T.getMonth() < 10 ? `0${T.getMonth()}` : T.getMonth();
        let day = T.getDay() < 10 ? `0${T.getDay()}` : T.getDay();
        let hours = T.getHours() < 10 ? `0${T.getHours()}` : T.getHours();
        let minutes =
          T.getMinutes() < 10 ? `0${T.getMinutes()}` : T.getMinutes();
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      },
      worldNameMap: {
        Afghanistan: "阿富汗",
        Angola: "安哥拉",
        Albania: "阿尔巴尼亚",
        "United Arab Emirates": "阿联酋",
        Argentina: "阿根廷",
        Armenia: "亚美尼亚",
        "French Southern and Antarctic Lands": "法属南半球和南极领地",
        Australia: "澳大利亚",
        Austria: "奥地利",
        Azerbaijan: "阿塞拜疆",
        Burundi: "布隆迪",
        Belgium: "比利时",
        Benin: "贝宁",
        "Burkina Faso": "布基纳法索",
        Bangladesh: "孟加拉国",
        Bulgaria: "保加利亚",
        "The Bahamas": "巴哈马群岛",
        "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
        Belarus: "白俄罗斯",
        Belize: "伯利兹",
        Bermuda: "百慕大",
        Bolivia: "玻利维亚",
        Brazil: "巴西",
        Brunei: "文莱",
        Bhutan: "不丹",
        Botswana: "博茨瓦纳",
        "Central African Republic": "中非共和国",
        Canada: "加拿大",
        Switzerland: "瑞士",
        Chile: "智利",
        China: "中国",
        "Ivory Coast": "象牙海岸",
        Cameroon: "喀麦隆",
        "Democratic Republic of the Congo": "刚果民主共和国",
        "Republic of the Congo": "刚果共和国",
        Colombia: "哥伦比亚",
        "Costa Rica": "哥斯达黎加",
        Cuba: "古巴",
        "Northern Cyprus": "北塞浦路斯",
        Cyprus: "塞浦路斯",
        "Czech Republic": "捷克共和国",
        Germany: "德国",
        Djibouti: "吉布地",
        Denmark: "丹麦",
        "Dominican Republic": "多明尼加共和国",
        Algeria: "阿尔及利亚",
        Ecuador: "厄瓜多尔",
        Egypt: "埃及",
        Eritrea: "厄立特里亚",
        Spain: "西班牙",
        Estonia: "爱沙尼亚",
        Ethiopia: "埃塞俄比亚",
        Finland: "芬兰",
        Fiji: "斐济",
        "Falkland Islands": "福克兰群岛",
        France: "法国",
        Gabon: "加蓬",
        "United Kingdom": "英国",
        // Georgia: "佐治亚州",
        Ghana: "加纳",
        Guinea: "几内亚",
        Gambia: "冈比亚",
        "Guinea Bissau": "几内亚比绍",
        "Equatorial Guinea": "赤道几内亚",
        Greece: "希腊",
        Greenland: "格陵兰",
        Guatemala: "危地马拉",
        "French Guiana": "法属圭亚那",
        Guyana: "圭亚那",
        Honduras: "洪都拉斯",
        Croatia: "克罗地亚",
        Haiti: "海地",
        Hungary: "匈牙利",
        Indonesia: "印度尼西亚",
        India: "印度",
        Ireland: "爱尔兰",
        Iran: "伊朗",
        Iraq: "伊拉克",
        Iceland: "冰岛",
        Israel: "以色列",
        Italy: "意大利",
        Jamaica: "牙买加",
        Jordan: "约旦",
        Japan: "日本本土",
        Kazakhstan: "哈萨克斯坦",
        Kenya: "肯尼亚",
        Kyrgyzstan: "吉尔吉斯斯坦",
        Cambodia: "柬埔寨",
        "South Korea": "韩国",
        Kosovo: "科索沃",
        Kuwait: "科威特",
        Laos: "老挝",
        Lebanon: "黎巴嫩",
        Liberia: "利比里亚",
        Libya: "利比亚",
        "Sri Lanka": "斯里兰卡",
        Lesotho: "莱索托",
        Lithuania: "立陶宛",
        Luxembourg: "卢森堡",
        Latvia: "拉脱维亚",
        Morocco: "摩洛哥",
        Moldova: "摩尔多瓦",
        Madagascar: "马达加斯加",
        Mexico: "墨西哥",
        Macedonia: "马其顿",
        Mali: "马里",
        Myanmar: "缅甸",
        Montenegro: "黑山共和国",
        Mongolia: "蒙古",
        Mozambique: "莫桑比克",
        Mauritania: "毛里塔尼亚",
        Malawi: "马拉维",
        Malaysia: "马来西亚",
        Namibia: "纳米比亚",
        "New Caledonia": "新喀里多尼亚",
        Niger: "尼日尔",
        // Nigeria: "奈及利亚",
        Nicaragua: "尼加拉瓜",
        Netherlands: "荷兰",
        Norway: "挪威",
        Nepal: "尼泊尔",
        "New Zealand": "新西兰",
        Oman: "阿曼",
        Pakistan: "巴基斯坦",
        Panama: "巴拿马",
        Peru: "秘鲁",
        Philippines: "菲律宾",
        "Papua New Guinea": "巴布亚新几内亚",
        Poland: "波兰",
        "Puerto Rico": "波多黎各",
        "North Korea": "朝鲜",
        Portugal: "葡萄牙",
        Paraguay: "巴拉圭",
        Qatar: "卡塔尔",
        Romania: "罗马尼亚",
        // Russia: "俄国",
        Rwanda: "卢旺达",
        "Western Sahara": "西撒哈拉",
        "Saudi Arabia": "沙特阿拉伯",
        Sudan: "苏丹",
        "South Sudan": "南苏丹",
        Senegal: "塞内加尔",
        "Solomon Islands": "所罗门群岛",
        "Sierra Leone": "塞拉利昂",
        "El Salvador": "萨尔瓦多",
        Somaliland: "索马里兰",
        Somalia: "索马里",
        "Republic of Serbia": "塞尔维亚共和国",
        Suriname: "苏里南",
        Slovakia: "斯洛伐克",
        Slovenia: "斯洛文尼亚",
        Sweden: "瑞典",
        Swaziland: "斯威士兰",
        Syria: "叙利亚",
        Chad: "乍得",
        Togo: "多哥",
        Thailand: "泰国",
        Tajikistan: "塔吉克斯坦",
        Turkmenistan: "土库曼斯坦",
        "East Timor": "东帝汶",
        "Trinidad and Tobago": "特立尼达和多巴哥",
        Tunisia: "突尼斯",
        Turkey: "土耳其",
        "United Republic of Tanzania": "坦桑尼亚联合共和国",
        Uganda: "乌干达",
        Ukraine: "乌克兰",
        Uruguay: "乌拉圭",
        "United States of America": "美国",
        Uzbekistan: "乌兹别克斯坦",
        Venezuela: "委内瑞拉",
        Vietnam: "越南",
        Vanuatu: "瓦努阿图",
        "West Bank": "西岸",
        Yemen: "也门",
        "South Africa": "南非",
        Zambia: "赞比亚",
        Zimbabwe: "津巴布韦",
        Singapore: "新加坡",
        Bahrain: "巴林",
        // "United Arab Emirates": "阿联酋",
        Russia: "俄罗斯",
        Georgia: "格鲁吉亚",
        Nigeria: "尼日利亚",
        Monaco: "摩纳哥",
        "North Macedonia": "北马其顿"
      },
      renderData: [],
      global: {}
    };
  },
  mounted() {
    getTxUnifiedData()
      .then(res => {
        console.log(res, 'ress------')
        // 中国的数据主动添加
        res.data.abroadCountryRanks.push(res.data.domestic[0]);
        this.renderData = res.data.abroadCountryRanks;
        this.global = res.data.global;
        setTimeout(() => {
          this.setChart();
        }, 100);
      })
      .catch(err => {
        console.log(err);
      });
  },
  created() {},
  methods: {
    md() {
      axios
        .get(
          `${BASE_URL}?deviceid=${window.localStorage.getItem(
            "nfplus_deviceid"
          )}&dataType=1000099&actionTime=${Date.parse(
            new Date()
          )}&origin=5&action=14&refer=${document.referrer}&url=${location.href}`
        )
        .then(res => {
          console.log(res);
          window.location.href =
            process.env.NODE_ENV === "production"
              ? "https://static.nfapp.southcn.com/hd/wdfyzb/"
              : "https://teststatic.nfapp.southcn.com/hd/wdfyzb/";
        })
        .catch(err => {
          window.location.href =
            process.env.NODE_ENV === "production"
              ? "https://static.nfapp.southcn.com/hd/wdfyzb/"
              : "https://teststatic.nfapp.southcn.com/hd/wdfyzb/";
        });
    },
    setChart() {
      const Chart = window.echarts.init(document.getElementById("chart"));
      let renderData = this.renderData;
      let datas = [];
      const data = renderData.map(item => {
        let areaColor;
        if (item.confirm > 99999) {
          areaColor = '#eb1800'
        } else if (item.confirm > 9999) {
          areaColor = "#fe614f";
        } else if (item.confirm > 999) {
          areaColor = "#ff7759";
        } else if (item.confirm > 499) {
          areaColor = "#fe8d59";
        } else if (item.confirm > 99) {
          areaColor = "#ffa768";
        } else if (item.confirm > 9) {
          areaColor = "#ffbf84";
        } else if (item.confirm > 0) {
          areaColor = "#fecf94";
        } else {
          areaColor = "#c7ccd5";
        }
        datas.push(item.country);
        return {
          name: Object.keys(this.worldNameMap).find(
            key => this.worldNameMap[key] == item.country
          ),
          chineseName: item.country,
          selected: false,
          value: item.confirm,
          itemStyle: {
            areaColor: areaColor,
            emphasis: {}
          }
        };
      });
      datas.forEach(ele => {
        if (ele == "中国") {
          console.log(ele);
        }
      });
      const option = {
        tooltip: {
          show: true,
          color: "#ff6300",
          formatter: function(params) {
            return params.data && params.data.chineseName
              ? `${params.data.chineseName}<br/>确诊：${params.data.value}`
              : "";
          }
        },
        series: [
          {
            name: "mapSer",
            type: "map",
            roam: false,
            zoom: 1.2,
            mapType: "world",
            label: {
              fontSize: 10,
              show: false,
              formatter: function(params) {
                return "";
              }
            },
            data: data,

            itemStyle: {
              normal: {
                areaColor: "#c7ccd5",
                borderColor: "#b5ddf1"
              },
              emphasis: {
                show: false
              }
            }
          }
        ]
      };
      Chart.setOption(option, true);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  font-family: MicrosoftYaHei;
  .titlePic {
    width: 100%;
    height: 109.5px;
    background: url("../../assets/images/titleBG.jpg") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    position: relative;
    img {
      margin-top: 35px;
      width: 259px;
    }
  }
  .mapBox {
    height: 216px;
    box-sizing: border-box;
    padding: 0 21px;
    #chart {
      height: 216px;
      border-radius: 3px;
      background: url("../../assets/images/border.png") no-repeat;
      background-size: 100% 100%;
      margin: 32px auto;
    }
  }
  .time {
    width: 100%;
    height: 33.5px;

    color: #ff604e;
    line-height: 33.5px;
    box-sizing: border-box;
    padding-top: 7.5px;
    padding-bottom: 10.5px;
    text-align: center;
    .timeOryq {
      line-height: 16.5px;
      width: 300px;
      height: 16.5px;

      margin: 0 auto;

      .beijin-time {
        text-align: center;
        font-size: 12px;
        line-height: 16.5px;

        height: 100%;
        float: left;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
          "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue",
          Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
          "Segoe UI Symbol";
      }
      .more {
        display: flex;
        float: right;
        line-height: normal;
        align-items: center;
        width: 96px;
        height: 16.5px;
        border-radius: 7.5px;
        background: #c0c0c0;
        box-sizing: border-box;
        padding: 0px 5px 0 9px;
        .moreConfirm {
          font-size: 10px;

          width: 72px;

          float: left;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
            "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
            "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
            "Segoe UI Emoji", "Segoe UI Symbol";
          color: #fff;
          vertical-align: middle;
        }
        .icon_right {
          width: 4px;
          height: 6px;
          margin-left: 3px;
          background: url("../../assets/images/icon_000.png") no-repeat;
          background-size: 100% 100%;
          vertical-align: middle;
        }
      }
    }
  }
  .tetailBox {
    width: 100%;
    height: 69.5px;
    box-sizing: border-box;
    padding-left: 2px;
    padding-right: 2.5px;
    display: flex;
    justify-content: space-between;
    .tetail {
      flex: 1;
      height: 69.5px;

      padding: 5px 0 7px 0;
      .paddingBox {
        width: 100%;
        height: 57.5px;
        border-right: 1px solid #c0c0c0;
        box-sizing: content-box;
        p {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
            "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
            "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
            "Segoe UI Emoji", "Segoe UI Symbol";
        }
        .number {
          font-weight: 650;
        }
      }
      &:last-child {
        .paddingBox {
          border: none;
        }
      }
      @media screen and (device-width: 320px) and (device-height: 480px) and (-webkit-device-pixel-ratio: 2) {
        .yesterday {
          transform: scale(0.833);
        }
      }
      @media screen and (device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) {

        .yesterday {
          transform: scale(0.833);
        }
      }
    }
    .Cumulative-diagnosis {
      .paddingBox {
        .yesterday {
          font-size: 11px;
          color: #ff604e;
          height: 12px;

          text-align: center;
          line-height: 12px;
          margin-top: 5px;
          box-sizing: content-box;
          padding-top: 5px;
        }
        .number {
          font-size: 18px;
          line-height: 17.5px;
          color: #ff604e;
          padding-top: 5px;

          box-sizing: content-box;

          height: 17.5px;
          text-align: center;
        }
        .text {
          font-size: 11px;
          color: #494949;
          padding-top: 3px;
          height: 12px;
          line-height: 12px;
          box-sizing: content-box;
          text-align: center;
        }
      }
    }
    .Existing-diagnosis {
      .paddingBox {
        .yesterday {
          font-size: 11px;
          color: #fea768;
          height: 12px;
          text-align: center;
          line-height: 12px;
          margin-top: 5px;
          box-sizing: content-box;
          padding-top: 5px;
        }
        .number {
          font-size: 18px;
          line-height: 17.5px;
          color: #fea768;
          padding-top: 5px;

          box-sizing: content-box;

          height: 17.5px;
          text-align: center;
        }
        .text {
          font-size: 11px;
          color: #494949;
          padding-top: 3px;
          height: 12px;
          line-height: 12px;
          box-sizing: content-box;
          text-align: center;
        }
      }
    }
    .Cumulative-cure {
      .paddingBox {
        .yesterday {
          font-size: 11px;
          color: #92c25e;
          height: 12px;
          text-align: center;
          line-height: 12px;
          margin-top: 5px;
          box-sizing: content-box;
          padding-top: 5px;
        }
        .number {
          font-size: 18px;
          line-height: 17.5px;
          color: #92c25e;
          padding-top: 5px;

          box-sizing: content-box;

          height: 17.5px;
          text-align: center;
        }
        .text {
          font-size: 11px;
          color: #494949;
          padding-top: 3px;
          height: 12px;
          line-height: 12px;
          box-sizing: content-box;
          text-align: center;
        }
      }
    }
    .Existing-cure {
      .paddingBox {
        .yesterday {
          font-size: 11px;
          color: #bd3627;
          height: 12px;
          text-align: center;
          line-height: 12px;
          margin-top: 5px;
          box-sizing: content-box;
          padding-top: 5px;
        }
        .number {
          font-size: 18px;
          line-height: 17.5px;
          color: #bd3627;
          padding-top: 5px;

          box-sizing: content-box;

          height: 17.5px;
          text-align: center;
        }
        .text {
          font-size: 11px;
          color: #494949;
          padding-top: 3px;
          height: 12px;
          line-height: 12px;
          box-sizing: content-box;
          text-align: center;
        }
      }
    }
  }
}
</style>
